<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="企业品牌" prop="tenantId" v-if="userTentant.type !== 1">
        <a-select
          show-search
          :allowClear="true"
          v-model="form.tenantId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="更新类型" prop="appType" v-if="userTentant.type !== 1">
        <a-radio-group v-model="form.appType">
          <a-radio-button :value="0"> 安卓 </a-radio-button>
          <a-radio-button :value="1"> 苹果 </a-radio-button>
          <a-radio-button :value="3"> 设备固件 </a-radio-button>
          <a-radio-button :value="4"> 维修wgt </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="是否强制更新" v-if="userTentant.type !== 1">
        <a-radio-group v-model="form.compulsoryUp">
          <a-radio-button :value="0"> 强制 </a-radio-button>
          <a-radio-button :value="1"> 可跳过 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="上传文件" prop="upUrl">
        <a-upload :disabled="isUploading" :file-list="fileList" :maxCount="1" :customRequest="customRequest">
          <a-button :loading="isUploading"> <a-icon type="upload" /> 上传文件 </a-button>
        </a-upload>
        <a-input v-model="form.upUrl" v-show="show"></a-input>
      </a-form-model-item>
      <!-- <a-form-model-item label="版本名称(1.0.0)" prop="versionName">
        <a-input v-model="form.versionName" placeholder="请输入" :maxLength="50" />
      </a-form-model-item> -->
      <a-form-model-item label="版本号(100)" prop="versionCode">
        <a-input v-model="form.versionCode" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="更新说明" prop="upNotes">
        <a-textarea v-model="form.upNotes" placeholder="请输入" :maxLength="250" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入" :maxLength="250" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import COS from 'cos-js-sdk-v5'
import moment from 'moment'
import { ossSignature } from '@/api/system/user'
import { getObj, addObj, putObj } from '@/api/pressure/version'
export default {
  name: 'CreateForm',
  components: {},
  props: {
    userList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      submitLoading: false,
      isUploading: false,
      data: [],
      formTitle: '',
      fileList: [],
      // 表单参数
      form: {
        id: undefined,
        appType: 0,
        compulsoryUp: 1,
        planUpTime: 1,
        planUpType: 1,
        upUrl: undefined,
        remark: undefined,
        upType: 0,
        upUrlType: 0,
        versionCode: undefined,
        versionName: undefined,
      },
      showLoading: false,
      open: false,
      show: false,
      rules: {
        upUrl: [{ required: true, message: '请选择上传文件', trigger: 'blur' }],
        versionName: [{ required: true, message: '请输入版本名称', trigger: 'blur' }],
        versionCode: [{ required: true, message: '请输入版本号', trigger: 'blur' }],
        upNotes: [{ required: true, message: '请输入更新说明', trigger: 'blur' }],
        tenantId: [{ required: true, message: '请选择企业品牌', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    onClose() {
      this.open = false
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        appType: 0,
        compulsoryUp: 1,
        planUpTime: 1,
        planUpType: 1,
        remark: undefined,
        upType: 0,
        upUrlType: 0,
        upUrl: undefined,
        versionCode: undefined,
        versionName: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '版本升级'
    },
    // 获取文件名称
    generateCosKey(name, ext) {
      var ymd = moment().format('YYYYMMDD')
      var ymd = moment().format('YYYYMMDD_HHmmss_')
      var r = ('000000' + Math.random() * 1000000).slice(-6)
      var cosKey = name + `/file_${ymd}_${r}.${ext}`
      return cosKey
    },
    customRequest(options) {
      const that = this
      this.isUploading = true
      const { file, onProgress, onSuccess, onError } = options
      this.fileList = [file] // 仅保留最新的一个文件
      console.log(file, onProgress, onSuccess, onError, 'file, onProgress, onSuccess, onError')
      console.log(file.name, '对对对对对对')
      var lastIndex = file.name.lastIndexOf('.')
      console.log('选择的图片路径fileName', lastIndex)
      var extName = lastIndex > -1 ? file.name.slice(lastIndex + 1) : ''
      console.log(extName, 'extNameextNameextName')
      const cosKey = this.generateCosKey(this.$cosUrl, extName)
      const fileNames = cosKey.split('/').pop()
      ossSignature().then((res) => {
        res = res.data
        const cos = new COS({
          SecretId: res.tmpSecretId,
          SecretKey: res.tmpSecretKey,
          SecurityToken: res.sessionToken, // sts服务下发的临时 SessionToken
          StartTime: res.startTime, // 建议传入服务端时间，可避免客户端时间不准导致的签名错误
          ExpiredTime: res.expiredTime, // 临时密钥过期时间
        })
        cos.putObject(
          {
            Bucket: this.$Bucket, // 对象存储桶名称
            Region: 'ap-beijing', // 地域
            Key: cosKey, // 文件路径
            Body: file, // 文件对象
            SliceSize:
              1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
            onProgress: function (progressData) {},
          },
          function (err, data) {
            if (err) {
              console.log('上传失败', err)
            } else {
              console.log('上传成功')
              // that.form.cosKey = cosKey
              console.log(cosKey, 'cosKeycosKey')
              that.form.upUrl = cosKey
              that.isUploading = false
              // that.handleOk(cosKey)
            }
          }
        )
      })
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改设备'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
           const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
